const FALLBACK = '/dashboard';
// A fixed, non-network origin keeps this pure and independent of runtime config.
const BASE = 'https://login-return.invalid';
const hasUnsafeCharacters = value => /[\\\u0000-\u001f\u007f]/.test(value);

/** Accept only unambiguous root-relative login returns, not general link URLs. */
export function safeLoginReturnPath(value) {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')
        || hasUnsafeCharacters(value)) return FALLBACK;

    try {
        // Inspect the path only: encoded URLs in query/hash are ordinary data.
        const pathname = value.split(/[?#]/, 1)[0];
        const decoded = decodeURIComponent(pathname);
        // Fail closed on nested escapes rather than repeatedly decoding input.
        if (hasUnsafeCharacters(decoded) || /%[0-9a-f]{2}/i.test(decoded)) return FALLBACK;
        for (const input of [value, decoded]) {
            const parsed = new URL(input, BASE);
            if (parsed.origin !== BASE || parsed.pathname.startsWith('//')) return FALLBACK;
        }
        // Preserve existing path/query/hash bytes, not the probe's normalization.
        return value;
    } catch {
        return FALLBACK;
    }
}
